import ReactGA from "react-ga4";

// Replace with your own GA4 Measurement ID
export const initGA = () => {
  ReactGA.initialize("G-3VWBBEQL6S"); //  // G-D0EP3BH9LG - from other project (democraticchess.com)
};

export const trackPageView = (url) => {
  ReactGA.send({ hitType: "pageview", page: url });
};

export const trackEvent = (action, category, label = "", value = 0) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
